import React from 'react'
import classnames from 'classnames'
import {
  Spin,
  Pagination,
  message,
  Form,
  Input,
  Button,
  Tooltip,
  DatePicker,
  Table,
  Divider,
  BackTop,
  Select,
  Modal,
  Checkbox,
  Radio,
  Upload
} from 'antd'
import {uploadErrHandle,tokenConfig} from '@/public/utils'
import styles from './commodity-qualification.module.less'
import common from '@/public/common'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import {PlusOutlined, UploadOutlined} from '@ant-design/icons'
const { Option } = Select
const { TextArea } = Input
class HistoryComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalTitle: '历史资质',
      visible: true,
      qualificationData: [],
      testUrl: window.location.host.split('t').length - 1 === 1
    }
  }

  componentDidMount () {
    let {qualificationData} = this.state
    this.setState(
      {
        type: this.props.type,
        modalTitle: this.props.type === 'history' ? '历史资质' : this.props.type === 'expired' ? '过期资质' : '预警资质'
      },
      () => {
        if (this.state.type === 'history') {
          this.setState({
            qualificationData: this.props.historyData
          })
        } else if (this.state.type === 'expired') {
          this.setState({
            qualificationData: this.props.overdueData
          })
        } else if (this.state.type === 'waring') {
          this.setState({
            qualificationData: this.props.waringData
          })
        }
      }
    )
  }

  //
  componentWillReceiveProps (nextprops) {
    let {qualificationData} = this.state
    this.setState(
      {
        type: this.props.type,
        modalTitle: nextprops.type === 'history' ? '历史资质' : nextprops.type === 'expired' ? '过期资质' : '预警资质'
      },
      () => {
        if (this.state.type === 'history') {
          this.setState({
            qualificationData: nextprops.historyData
          })
        } else if (this.state.type === 'expired') {
          this.setState({
            qualificationData: nextprops.overdueData
          })
        } else if (this.state.type === 'waring') {
          this.setState({
            qualificationData: nextprops.waringData
          })
        }
      }
    )
  }

  // 获取输入框的值
  handleChangeInput = (e, index, index2, name) => {
    let { qualificationData, testUrl, editData, postData } = this.state
    qualificationData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        item.qua_filed_value = e.target.value
      }
    })
    this.setState(
      {
        qualificationData
      })
  };

  // 获取下拉框的值
  handelSelect=(e, index, index2, name) => {
    let { qualificationData, testUrl, editData, postData } = this.state
    qualificationData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        item.qua_filed_value = e
      }
    })

    this.setState(
      {
        qualificationData
      })
  }

  // 获取时间的值
  handleChangeDate = (e, index, index2, name) => {
    let { qualificationData, testUrl, editData, postData } = this.state
    qualificationData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        item.qua_filed_value = e ? moment(e).valueOf() : null
      }
    })

    this.setState(
      {
        qualificationData
      })
  };

  // 图片上传
  handleChangeResponsibility = (index, index2, name, { file, fileList }) => {
    let { qualificationData, testUrl, editData, postData } = this.state

    if (file.status === 'done') {
      fileList = fileList.map((item, index) => {
        // 相关文件对象数据格式化处理
        return item
      })
    }
    let _index
    qualificationData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
        item.imgList = uploadErrHandle(file, fileList)
      }
    })
    qualificationData[index].qua_value[index2][_index].imgList.map((item) => {
      if (item.response) {
        item.url = common.imageUrl+'po/qua/image/' + item.response.url
        qualificationData[index].qua_value[index2][
          _index
        ].qua_filed_value.push(item.response.url)
        qualificationData[index].qua_value[index2][
          _index
        ].qua_filed_value = _lodash.uniqWith(
          qualificationData[index].qua_value[index2][_index].qua_filed_value,
          _lodash.isEqual
        )
      }
    })

    // 避免原来的文件丢失，这样子写就可以了
    this.setState(
      {
        qualificationData,
        editData
      }
    )
  };

  // 删除图片
  handleDeleteImg = (index, index2, name, file) => {
    let { qualificationData, testUrl, editData, postData } = this.state
    let _url = file.response.url
    let _index
    qualificationData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
      }
    })

    qualificationData[index].qua_value[index2][_index].qua_filed_value.map(
      (item, i) => {
        if (item === _url) {
          qualificationData[index].qua_value[index2][
            _index
          ].qua_filed_value.splice(i, 1)
        }
      }
    )
    this.setState(
      {
        qualificationData,
        editData
      }
    )
  };

  // 文件上传
  handleChangeFileAuthorize = (index, index2, name, { file, fileList }) => {
    let { qualificationData, testUrl, editData, postData } = this.state
    // let fileList = [...info.fileList]
    // 1. 限制上载的文件数
    // 只显示两个最近上传的文件，旧文件将被新文件替换
    // fileList = fileList.slice(-2)
    // 2. 从响应读取并显示文件链接
    if (file.status === 'done') {
      fileList = fileList.map((item, index) => {
        // 相关文件对象数据格式化处理
        return item
      })
    }

    let _index
    qualificationData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
        item.fileListNew = uploadErrHandle(file, fileList)
      }
    })

    qualificationData[index].qua_value[index2][_index].fileListNew = fileList
    qualificationData[index].qua_value[index2][_index].fileListNew.map(
      (item) => {
        let _urlCode = []
        if (item.response) {
          item.url = common.imageUrl+'po/qua/file/' + item.response.url
          _urlCode.push(item.response.url)
          qualificationData[index].qua_value[index2][
            _index
          ].qua_filed_value.push(item.response.url)
          qualificationData[index].qua_value[index2][
            _index
          ].qua_filed_value = _lodash.uniqWith(
            qualificationData[index].qua_value[index2][_index].qua_filed_value,
            _lodash.isEqual
          )
        }
      }
    )

    this.setState(
      {
        qualificationData,
        editData
      }
    )
  };

  // 删除文件
  handleDeleteFile = (index, index2, name, file) => {
    let { qualificationData, testUrl, editData, postData } = this.state
    let _url = file.response.url
    let _index
    qualificationData[index].qua_value[index2].map((item, m) => {
      if (item.qua_filed_name === name) {
        _index = m
      }
    })

    qualificationData[index].qua_value[index2][_index].qua_filed_value.map(
      (item, i) => {
        if (item === _url) {
          qualificationData[index].qua_value[index2][
            _index
          ].qua_filed_value.splice(i, 1)
        }
      }
    )
    this.setState(
      {
        qualificationData
      }
    )
  };

  // 取消
  handleCancel = () => {
    this.props.handleVisible(false)
  };

  render () {
    let {qualificationData} = this.state
    const uploadButton = (
      <div >
        <PlusOutlined />
        <div className="ant-upload-text">上传</div>
      </div>
    )
    return (
      <div>
        <Modal
          title={this.state.modalTitle}
          visible={this.state.visible}
          onOk={this.handleOk}
          width={1200}
          onCancel={this.handleCancel}
          footer={false}
        >
          {qualificationData && qualificationData.length !== 0
            ? qualificationData.map((item, index) => {
              return (
                <div>
                  <div
                    style={{
                      fontSize: '20px',
                      color: 'red',
                      marginBottom: '24px',
                      display: 'none'
                    }}
                  >
                    <span>商品名称：</span>
                    <span>{item.item_name}</span>
                  </div>
                  {item.qua_value
                    ? item.qua_value.map((item2, index2) => {
                      let _item2 = _lodash.filter(item2, (value) => {
                        return (
                          value !== null &&
                            value.qua_filed_name === '资质名称'
                        )
                      })
                      let _dataItemData = _lodash.filter(
                        item2,
                        (value) => {
                          return (
                            value !== null &&
                              (value.qua_filed_name === '开始时间' ||
                                value.qua_filed_name === '结束时间')
                          )
                        }
                      )
                      let _item2New = _lodash.filter(item2, (value) => {
                        return (
                          value !== null &&
                            value.qua_filed_name !== '资质名称' &&
                            value.qua_filed_name !== '开始时间' &&
                            value.qua_filed_name !== '结束时间'
                        )
                      })
                      return (
                        <div
                          key={index2}
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            border: '1px solid lavender',
                            marginBottom: '24px',
                            padding: '16px 16px'
                          }}
                        >
                          <div
                            style={{
                              width: '49%',
                              marginBottom: '16px'
                            }}
                          >
                            <span
                              style={{
                                display: 'inline-block',
                                textAlign: 'right',
                                width: '112px',
                                float: 'left'
                              }}
                            >
                              <span style={{ color: 'red' }}>*</span>
                                  资质名称：
                            </span>
                            <span
                              style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                lineHeight: '24px'
                              }}
                            >
                              {_item2[0].qua_filed_value}
                            </span>
                          </div>
                          <div
                            style={{
                              width: '49%',
                              marginBottom: '16px',
                              lineHeight: '24px',
                              display:
                                  _dataItemData &&
                                  _dataItemData.length !== 0
                                    ? 'inline-block'
                                    : 'none'
                            }}
                          >
                            <span
                              style={{
                                display: 'inline-block',
                                textAlign: 'right',
                                width: '112px'

                              }}
                            >
                              <span
                                style={{
                                  color: 'red',
                                  display:
                                      _dataItemData &&
                                      _dataItemData.length !== 0
                                        ? _dataItemData[0].is_need === 1
                                          ? 'inline-block'
                                          : 'none'
                                        : 'none'
                                }}
                              >
                                  *
                              </span>
                                有效时间：
                            </span>
                            {_dataItemData
                              ? _dataItemData.map((m, n) => {
                                return (
                                  <DatePicker
                                    onOpenChange={
                                      this.handleOpenChange
                                    }
                                    disabled
                                    format="YYYY-MM-DD"
                                    style={{
                                      width: '144px',
                                      marginRight: '8px',
                                      verticalAlign: 'middle'
                                    }}
                                    onPanelChange={
                                      this.handlePanelChange
                                    }
                                    onChange={(e) =>
                                      this.handleChangeDate(
                                        e,
                                        index,
                                        index2,
                                        m.qua_filed_name
                                      )
                                    }
                                    value={
                                      m.qua_filed_value
                                        ? moment(
                                          m.qua_filed_value * 1
                                        )
                                        : null
                                    }
                                  />
                                )
                              })
                              : null}
                          </div>
                          {_item2New
                            ? _item2New.map((item3, index3) => {
                              return (
                                <div
                                  key={index3}
                                  style={{
                                    width: '49%',
                                    marginBottom: '16px'
                                  }}
                                >
                                  <div>
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        textAlign: 'right',
                                        width: '112px',
                                        float: item3.qua_filed_type === 'Picture' ? 'left' : 'none'
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: 'red',
                                          display:
                                                  item3.is_need === 1
                                                    ? 'inline-block'
                                                    : 'none'
                                        }}
                                      >
                                              *
                                      </span>
                                      {item3.qua_filed_name + '：'}
                                    </span>
                                    {item3.qua_filed_type === 'Text' ? (
                                      <span>
                                        {' '}
                                        <Input
                                          placeholder="请输入"
                                          disabled
                                          value={
                                            item3.qua_filed_value
                                              ? item3.qua_filed_value
                                              : ''
                                          }
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e,
                                              index,
                                              index2,
                                              item3.qua_filed_name
                                            )
                                          }
                                          style={{
                                            width: 272,
                                            marginRight: '8px',
                                            verticalAlign: 'middle'
                                          }}
                                        />
                                      </span>
                                    ) : item3.qua_filed_type ===
                                            'Picture' ? (
                                        <span
                                          style={{
                                            display: 'inline-block',
                                            width: '79%'
                                          }}
                                        >
                                          <Upload
                                            action = {common.scpUrl + 'item/upload-image'}
                                            headers={{...tokenConfig}}
                                            listType="picture-card"
                                            //   multiple={true}
                                            accept="image/jpeg,image/jpg,image/png"
                                            fileList={item3.imgList ? item3.imgList : []}
                                            disabled
                                            //   beforeUpload={this.handleBeforeUploadResponsibility}
                                            onPreview={
                                              this
                                                .handlePreviewResponsibility
                                            }

                                            onChange={(e) => {
                                              this.handleChangeResponsibility(
                                                index,
                                                index2,
                                                item3.qua_filed_name,
                                                e
                                              )
                                            }}
                                            onRemove={(e) =>
                                              this.handleDeleteImg(
                                                index,
                                                index2,
                                                item3.qua_filed_name,
                                                e
                                              )
                                            }
                                          >
                                            {item3.imgList ? item3.imgList.length >= 8
                                              ? null
                                              : uploadButton : uploadButton}
                                          </Upload>
                                          <Modal
                                            visible={false}
                                            footer={null}
                                            onCancel={this.handleCancel}
                                          >
                                            <img
                                              alt="example"
                                              style={{ width: '100%' }}
                                              src={''}
                                            />
                                          </Modal>
                                        </span>
                                      ) : item3.qua_filed_type ===
                                            'File' ? (
                                          <span className={styles.filestyle}>
                                            <Upload
                                              action= {common.scpUrl + 'item/upload-image'}
                                              headers={{...tokenConfig}}
                                              accept=".pdf"
                                              disabled
                                              onChange={(e) =>
                                                this.handleChangeFileAuthorize(
                                                  index,
                                                  index2,
                                                  item3.qua_filed_name,
                                                  e
                                                )
                                              }
                                              onRemove={(e) =>
                                                this.handleDeleteFile(
                                                  index,
                                                  index2,
                                                  item3.qua_filed_name,
                                                  e
                                                )
                                              }
                                              fileList={item3.fileListNew ? item3.fileListNew : []}
                                            >
                                              <Button disabled>
                                                <UploadOutlined />
                                                  上传文件
                                              </Button>
                                              <span
                                                style={{
                                                  display: 'inline-block',
                                                  marginLeft: '8px',
                                                  color: '#cccccc'
                                                }}
                                              >
                                                  仅支持扩展名：.pdf
                                              </span>
                                            </Upload>
                                          </span>
                                        ) : item3.qua_filed_type ===
                                          'Select' ? (
                                            <span>
                                              <Select
                                                showSearch
                                                // mode="multiple"
                                                disabled
                                                style={{
                                                  width: 272,
                                                  marginRight: '8px',
                                                  verticalAlign: 'middle'
                                                }}
                                                optionFilterProp="children"
                                                placeholder="请选择"
                                                value={
                                                  item3.qua_filed_value
                                                }
                                                onChange={(e) =>
                                                  this.handelSelect(
                                                    e,
                                                    index,
                                                    index2,
                                                    item3.qua_filed_name
                                                  )
                                                }
                                              >
                                                <Option key={0} value={0}>
                                                否
                                                </Option>
                                                <Option key={1} value={1}>
                                                是
                                                </Option>
                                              </Select>
                                            </span>
                                          ) : null}
                                  </div>
                                </div>
                              )
                            })
                            : null}
                        </div>
                      )
                    })
                    : null}
                </div>
              )
            })
            : <div style={{textAlign: 'center', padding: '16px 0px', fontSize: '16px'}}>暂无数据</div>}
          <div style={{ textAlign: 'center', marginTop: '24px', display: 'none' }}>
            <Button
              type="primary"
              style={{ marginLeft: '16px' }}
              onKeyDown={this.onKeyup}
              //   loading={btnLoadings.okLoading}
              onClick={(e) => this.handleOk(e)}
            >
              确定
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: '16px' }}
              onKeyDown={this.onKeyup}
              onClick={this.handleCancel}
            >
              取消
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}
export default HistoryComponent



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commodityqualification/historycomponent.js